const connectWithPayPal = require('./cwpp/connectWithPayPal');

const SessionStorageModel = require('./models/sessionStorage');
const AlertHandlerModel = require('./models/alertHandler');

const sessionStorageInstance = new SessionStorageModel();

const $applePayContent = document.querySelector('.js-apple-pay-content');
// const amount = parseFloat(document.querySelector('.grand-total-sum').textContent.trim().replace(/[^0-9.-]/g, ''));
// const isOrderZeroAmount = !isNaN(amount) && amount === 0;
const alertHandler = new AlertHandlerModel();

if (window.paypalPreferences.isPayNowFlowEnabled) {
    $('.js-submit-shipping').on('click', function() {
        const ShipmentsDomModel = require('./models/shipmentsDom');

        const shipmentsDomInstance = new ShipmentsDomModel();

        shipmentsDomInstance.setOnlinePickUpShippingMethod();
    });
}

import { updateCheckoutView } from './helpers/helper';

import {
    handleTabChange,
    togglePaypalBtnVisibility,
    toggleVenmoBtnVisibility,
    updateSessionAccountEmail,
    updateClientSide,
    updateSubmitOrderButton,
    shippingAddressFormFillingVerifing,
    isShippingAddressFormEmptyChecking
} from './billing/billingHelper';

import {
    toggleBABtnVisibility,
    assignEmailForSavedBA,
    handleCheckboxChange
} from './billing/registered/billingAgreementHelper';

// Mark 'credit-card' tab as active if no tab is set in session
if (!sessionStorageInstance.getActiveBillingPmTab()) {
    sessionStorageInstance.setActiveBillingPmTab(window.paypalConstants.CREDIT_CARD_TAB);
}

const $restPaypalAccountsList = document.getElementById('restPaypalAccountsList');
const $isSavedPayPalAccount = document.getElementById('paypalAccountsDropdown');
const $restVenmoAccountsList = document.getElementById('restVenmoAccountsList');
const isRegisteredUser = document.querySelector('.data-checkout-stage').getAttribute('data-customer-type') === 'registered';
const $billingButtonContainer = document.getElementById('billing-paypal-button-container');
const isBAEnabled = $billingButtonContainer && window.paypalPreferences.billingAgreementEnabled;
const isHostedFields = window.paypal.HostedFields && window.paypal.HostedFields.isEligible();

if (window.paypalPreferences.isCWPPEnabled) {
    connectWithPayPal.init();
}

/**
 * Activates the PayPal tab
 */
const activatePayPalTab = () => {
    const $ppPaymentOptionID = document.querySelector('.nav-link.paypal-tab').parentElement.getAttribute('data-method-id');
    const $activeTab = document.querySelector('.payment-information');

    document.querySelector('.nav-item .paypal-tab').click();

    if ($ppPaymentOptionID !== $activeTab.getAttribute('data-payment-method-id')) {
        $activeTab.setAttribute('data-payment-method-id', $ppPaymentOptionID);
    }
};

const activateHostedFieldsTab = () => {
    const hostedFieldsTab = document.querySelector('.nav-item .js-credit-card-tab');
    const tabHash = hostedFieldsTab.hash;

    handleTabChange(tabHash, sessionStorageInstance);
};

$('body').on('checkout:updateCheckoutView', (e, data) => {
    e.stopPropagation();

    updateClientSide(data);
    updateCheckoutView(data);

    /*const isSessionPaymentsEnabled = JSON.parse(document.querySelector('.js-payment-information').dataset.sessionPaymentsEnabled);

    if ((!isRegisteredUser || !isBAEnabled) && isSessionPaymentsEnabled) {
        updateSessionAccountEmail(data);
    }

    if (!isBAEnabled) {
        updateSubmitOrderButton();
    }*/
});

$('.payment-options[role=tablist] a[data-toggle="tab"]').on('shown.bs.tab', e => {
    handleTabChange(e, sessionStorageInstance);
});

// Order id flow
if (window.paypal && !isBAEnabled) {
    const PayPalBaseModel = require('./models/buttons/payPalBase');
    const payPalBaseInstance = new PayPalBaseModel('.js-paypal-button-on-billing-form');
    const $lpmBtns = document.querySelectorAll('.js-lpm-btn');
    const $venmoContent = document.querySelector('.js-venmo-content');

    if ($venmoContent) {
        const venmoBaseInstance = new PayPalBaseModel('.js-venmo-btn');

        venmoBaseInstance.initPayPalButton(window.paypal.FUNDING.VENMO);
    }

    if ($lpmBtns.length) {
        const lpmsBuilder = require('./billing/lpmsBuilder');

        lpmsBuilder.initLpms($lpmBtns);
    }

    payPalBaseInstance.initPayPalButton();

    if (isHostedFields && payPalBaseInstance.isPayNowFlowEnabled) {
        activateHostedFieldsTab();
    }
} else {
    if (window.paypal && isBAEnabled) {
        const PayPalBillingBAModel = require('./models/billingAgreement/payPalBilling');
        const payPalBillingInstance = new PayPalBillingBAModel('.paypal-checkout-ba-button');

        payPalBillingInstance.initPayPalButton();

        assignEmailForSavedBA();
    }

    activatePayPalTab();
}

// if ($isSavedPayPalAccount && isOrderZeroAmount) {
//     const $continueButton = document.querySelector('button.submit-payment');

//     $continueButton.addEventListener('click', event => {
//         event.preventDefault();
//         event.stopPropagation();

//         alertHandler.showError(window.paypalConstants.ZERO_AMOUNT_ERROR_MESSAGE);
//     });
// }

if ($restPaypalAccountsList) {
    $restPaypalAccountsList.onchange = function(e) {
        const $accountList = e ? e.target : $restPaypalAccountsList;

        if (!isBAEnabled) {
            togglePaypalBtnVisibility($accountList);
        } else {
            toggleBABtnVisibility($accountList);
            assignEmailForSavedBA();
        }
    };
}

if ($restVenmoAccountsList) {
    $restVenmoAccountsList.onchange = function() {
        toggleVenmoBtnVisibility(this);
    };
}

if (!isBAEnabled) {
    updateSubmitOrderButton();

    // document.querySelector('.payment-summary .edit-button').onclick = function() {
    //     document.querySelector('button.place-order').innerText = 'Place Order';
    // };
}

if (document.querySelector('.paypal-checkbox-container')) {
    document.querySelectorAll('.paypal-checkbox-container .custom-checkbox')
        .forEach(checkbox => checkbox.addEventListener('change', handleCheckboxChange));
}

// This functionality checks that the shipping address form is filled out correctly
const isShippingAddressFormFillied = shippingAddressFormFillingVerifing();
const isShippingAddressFormEmpty = isShippingAddressFormEmptyChecking();
const $shippingEditButton = document.querySelector('.shipping-summary .edit-button');
const $shippingUpdateButton = document.querySelector('.shipping-address .shipment-selector-block .form-group .btn-show-details');
const $shippingSubmitButton = document.querySelector('.submit-shipping');

if (window.location.hash === '#placeOrder' && !isShippingAddressFormFillied && $shippingEditButton && $shippingSubmitButton) {
    $shippingEditButton.click();
    $shippingSubmitButton.click();
}

if (window.location.hash === '#shipping'
    && !isShippingAddressFormEmpty
    && !isShippingAddressFormFillied
    && $shippingUpdateButton
    && $shippingSubmitButton) {
    $shippingUpdateButton.click();
    $shippingSubmitButton.click();
}

if (isHostedFields) {
    require('./billing/creditCard')();
}

if ($applePayContent) {
    const ApplePaySession = window.ApplePaySession;

    if (ApplePaySession && ApplePaySession.canMakePayments()) {
        const ApplePayModel = require('./models/buttons/applePay');
        const applePayInstance = new ApplePayModel();

        applePayInstance.initApplePay();
    }
}

// Selects first found billing address if switched to PPL and a new billing address was selected
const $paymentOptionPPLTab = document.querySelector('.js-nav-item-paypal');
const $billingAddressSelector = document.getElementById('billingAddressSelector');

if ($paymentOptionPPLTab) {
    $paymentOptionPPLTab.addEventListener('click', function() {
        if ($billingAddressSelector && $billingAddressSelector.value === 'new') {
            const options = $billingAddressSelector.options;

            for (const option of options) {
                if (option.value !== 'new' && option.hasAttribute('data-first-name')) {
                    $billingAddressSelector.value = option.value;

                    break;
                }
            }
        }

        $billingAddressSelector.dispatchEvent(new Event('change'));
    });
}
